import React, { Suspense } from 'react';

import { IApplicationPage } from 'application/pages/types';
import PAGES_CONST from 'application/pages/constants';
import { LocalAccessRoles } from 'application/providers/AuthProvider';
import LoadingScreen from '@zvuk-b2b/react-uikit/ui/LoadingScreen';

export const WELCOME_PAGE_PATH = '/create-company';

const Renderer = React.lazy(() => import('./renderer'));

const WelcomePageWrapper: IApplicationPage = () => (
  <Suspense fallback={<LoadingScreen delay={PAGES_CONST.LOADER_SCREEN_DELAY} />}>
    <Renderer />
  </Suspense>
);

WelcomePageWrapper.config = {
  routes: [{ path: WELCOME_PAGE_PATH }],
  access: [LocalAccessRoles.AUTHORIZED],
};

export default WelcomePageWrapper;
